import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appFakeContent]'
})
export class FakeContentDirective {

  constructor(
    public viewContainerRef: ViewContainerRef
  ) { }

}
